import { connect } from 'react-redux';

import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { entitySelectors } from '@store/entity/selectors';

import { SpaTreatmentsCategoryV2 } from './SpaTreatmentsCategoryV2';

const mapStateToProps = (state) => ({
  property: entitySelectors.getProperty(state),
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

export const SpaTreatmentsCategoryV2Connected = connect(mapStateToProps)(SpaTreatmentsCategoryV2);
